import { type FunctionComponent, type PropsWithChildren } from 'react';
import { callIfPresent } from '../../../../utils/function.utils';
import { useRouteChange } from '../../../hooks/routing/route-change.hook';

export class SPANavNotifier {
	/* single point of entry for notifying SPA navigation events */
	static notify() {
		this.notifyMedallia();
	}
	/* Medalia needs to know when the page changes so that feedback
	 * can be correlated to the correct page. */
	static notifyMedallia() {
		callIfPresent(window?.KAMPYLE_ONSITE_SDK?.updatePageView);
	}
}

type ApplicationEventListenerProps = PropsWithChildren;

/**
 * Handles reporting of applicaiton level events to third parties.
 */
export const ApplicationObserver: FunctionComponent<ApplicationEventListenerProps> = ({ children }) => {
	useRouteChange(() => {
		SPANavNotifier.notify();
	});
	return <>{children}</>;
};
